import React from "react";
import "../styles/Preloader.css";

function Preloader() {
  return (
    <div className="preloader">
      <div className="preloader__content">
        <div className="preloader__icon-wrap">
          <img src="./logo.jpeg" alt="" className="preloader__icon" />
        </div>
        <div className="preloader__wordmark-wrap">
          <img src="./logoimg.jpeg" alt="Connect Moon" className="preloader__wordmark" />
        </div>
      </div>
      <div className="preloader__bar">
        <div className="preloader__bar-fill" />
      </div>
    </div>
  );
}

export default Preloader;
